import React, { useState, useEffect } from 'react';

const EmployeeMasterReportPrint = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reportParams, setReportParams] = useState({
    branch: "",
    department: ""
  });

  // Extract parameters from URL or use default values
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const params = {
      branch: urlParams.get('branch') || '8',
      department: urlParams.get('department') || 'ALL',
    };
    setReportParams(params);
  }, []);

  // Function to call the API (replace with your actual API endpoint)
  const fetchReportData = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const queryParams = new URLSearchParams(reportParams);
      // Replace with your actual API endpoint
      const response = await fetch(`https://www.nissi-india.com/api/employee_master_report?${queryParams}`);
      console.log("params:", queryParams);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log("response:", data);
      setReportData(data.data || []);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching report data:', err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data when component mounts or parameters change
  useEffect(() => {
    fetchReportData();
  }, [reportParams]);

  return (
    <div className="max-w-full mx-auto p-4 bg-white font-sans text-xs print:p-0 print:max-w-none overflow-x-auto">
      {/* Header Section */}
      <div className="border-2 border-black mb-0 min-w-[1400px]">
        <div className="border-b border-black flex">
          {/* Logo Section */}
          <div className="w-32 border-r border-black p-2 flex items-center justify-center">
            <div className="bg-black text-white px-2 py-1 text-xs font-bold text-center">
              <div>NISSI</div>
              <div>INFOTECH PVT LTD</div>
            </div>
          </div>
          
          {/* Company Info Section */}
          <div className="flex-1 p-3">
            <div className="text-center">
              <h1 className="text-lg font-bold mb-1">Nissi Infotech</h1>
              <div className="text-xs">
                <div>Nissi</div>
                <div className="font-bold">CIVIL CONSTRUCTION</div>
                <div>3/42-12, Nagappa colony, kavundampalayam,641600, Tamil Nadu, India.</div>
                <div>Phone No: 9003744644 infraconsoft-implementation@nissi</div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Report Title */}
        <div className="text-center py-2 border-b border-black font-bold">
          EMPLOYEE MASTER REPORT
        </div>
      </div>

      {/* Loading/Error States */}
      {loading && (
        <div className="text-center py-4">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-black"></div>
          <div className="mt-2">Loading report data...</div>
        </div>
      )}

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
          <div className="font-bold">Error loading report:</div>
          <div>{error}</div>
          <button 
            onClick={fetchReportData}
            className="mt-2 bg-red-600 text-white px-3 py-1 rounded text-xs hover:bg-red-700"
          >
            Retry
          </button>
        </div>
      )}

      {/* Table Section */}
      <div className="border-l-2 border-r-2 border-b-2 border-black min-w-[1400px]">
        <table className="w-full text-xs">
          <thead>
            <tr className="border-b border-black">
              <th className="border-r border-black px-1 py-1 w-8">S.No</th>
              <th className="border-r border-black px-1 py-1 w-16">
                <div>Employee</div>
                <div>Code</div>
              </th>
              <th className="border-r border-black px-1 py-1 w-24">Employee Name</th>
              <th className="border-r border-black px-1 py-1 w-20">Designation</th>
              <th className="border-r border-black px-1 py-1 w-12">PF No.</th>
              <th className="border-r border-black px-1 py-1 w-12">A.C No.</th>
              <th className="border-r border-black px-1 py-1 w-16">DOB</th>
              <th className="border-r border-black px-1 py-1 w-16">Qualification</th>
              <th className="border-r border-black px-1 py-1 w-16">DOJ</th>
              <th className="border-r border-black px-1 py-1 w-16">
                <div>Gross</div>
                <div>Salary</div>
              </th>
              <th className="border-r border-black px-1 py-1 w-12">
                <div>Basic</div>
                <div>Pay</div>
              </th>
              <th className="border-r border-black px-1 py-1 w-12">
                <div>Basic</div>
                <div>%</div>
              </th>
              <th className="border-r border-black px-1 py-1 w-16">
                <div>Gross</div>
                <div>Total</div>
              </th>
              <th className="border-r border-black px-1 py-1 w-12">
                <div>Special</div>
                <div>Pay</div>
              </th>
              <th className="border-r border-black px-1 py-1 w-8">PF</th>
              <th className="border-r border-black px-1 py-1 w-8">Hire</th>
              <th className="px-1 py-1 w-20">Location</th>
            </tr>
          </thead>
          <tbody>
            {!loading && reportData.length === 0 ? (
              <tr>
                <td colSpan="17" className="p-4 text-center text-gray-500">
                  No data available for the selected criteria
                </td>
              </tr>
            ) : (
              reportData.map((item, index) => (
                <tr key={index} className="border-b border-gray-300">
                  <td className="border-r border-black px-1 py-1 text-center">{index + 1}</td>
                  <td className="border-r border-black px-1 py-1">{item.employeeCode || ""}</td>
                  <td className="border-r border-black px-1 py-1">{item.employeeName || ""}</td>
                  <td className="border-r border-black px-1 py-1">{item.designation || ""}</td>
                  <td className="border-r border-black px-1 py-1 text-center">{item.pfNo || ""}</td>
                  <td className="border-r border-black px-1 py-1 text-center">{item.acNo || ""}</td>
                  <td className="border-r border-black px-1 py-1 text-center">{item.dob || ""}</td>
                  <td className="border-r border-black px-1 py-1">{item.qualification || ""}</td>
                  <td className="border-r border-black px-1 py-1 text-center">{item.doj || ""}</td>
                  <td className="border-r border-black px-1 py-1 text-right">
                    {Number(item.grossSalary || 0).toFixed(2)}
                  </td>
                  <td className="border-r border-black px-1 py-1 text-right">
                    {Number(item.basicPay || 0).toFixed(2)}
                  </td>
                  <td className="border-r border-black px-1 py-1 text-right">
                    {Number(item.basicPercentage || 0).toFixed(2)}
                  </td>
                  <td className="border-r border-black px-1 py-1 text-right">
                    {Number(item.grossTotal || 0).toFixed(2)}
                  </td>
                  <td className="border-r border-black px-1 py-1 text-right">
                    {Number(item.specialPay || 0).toFixed(2)}
                  </td>
                  <td className="border-r border-black px-1 py-1 text-center">{item.pf || "No"}</td>
                  <td className="border-r border-black px-1 py-1 text-center">{item.hire || "No"}</td>
                  <td className="px-1 py-1">{item.location || "HEAD OFFICE"}</td>
                </tr>
              ))
            )}

            {/* Sample data row to match the screenshot */}
            <tr className="border-b border-gray-300">
              <td className="border-r border-black px-1 py-1 text-center">1</td>
              <td className="border-r border-black px-1 py-1">RAMAN</td>
              <td className="border-r border-black px-1 py-1">CNC OPERATOR</td>
              <td className="border-r border-black px-1 py-1">01</td>
              <td className="border-r border-black px-1 py-1 text-center">7234567</td>
              <td className="border-r border-black px-1 py-1 text-center">01 Jan 1990</td>
              <td className="border-r border-black px-1 py-1 text-center"></td>
              <td className="border-r border-black px-1 py-1">01 Feb 2018</td>
              <td className="border-r border-black px-1 py-1 text-right">71,900.00</td>
              <td className="border-r border-black px-1 py-1 text-right">0.00</td>
              <td className="border-r border-black px-1 py-1 text-right">0.00</td>
              <td className="border-r border-black px-1 py-1 text-right">71,900.00</td>
              <td className="border-r border-black px-1 py-1 text-right">15,986.00</td>
              <td className="border-r border-black px-1 py-1 text-center">Yes</td>
              <td className="border-r border-black px-1 py-1 text-center"></td>
              <td className="px-1 py-1">HEAD OFFICE</td>
            </tr>

            <tr className="border-b border-gray-300">
              <td className="border-r border-black px-1 py-1 text-center">2</td>
              <td className="border-r border-black px-1 py-1">852</td>
              <td className="border-r border-black px-1 py-1">PRASAD K</td>
              <td className="border-r border-black px-1 py-1">SUPPORT ENGG</td>
              <td className="border-r border-black px-1 py-1 text-center">900</td>
              <td className="border-r border-black px-1 py-1 text-center">78874755</td>
              <td className="border-r border-black px-1 py-1 text-center">01 Jan 1990</td>
              <td className="border-r border-black px-1 py-1"></td>
              <td className="border-r border-black px-1 py-1 text-center">06 Nov 2018</td>
              <td className="border-r border-black px-1 py-1 text-right">71,900.00</td>
              <td className="border-r border-black px-1 py-1 text-right">0.00</td>
              <td className="border-r border-black px-1 py-1 text-right">0.00</td>
              <td className="border-r border-black px-1 py-1 text-right">71,900.00</td>
              <td className="border-r border-black px-1 py-1 text-right">15,986.00</td>
              <td className="border-r border-black px-1 py-1 text-center">No</td>
              <td className="border-r border-black px-1 py-1 text-center"></td>
              <td className="px-1 py-1">HEAD OFFICE</td>
            </tr>

            {/* Additional sample rows would go here */}
          </tbody>
        </table>
      </div>

      {/* Report Footer */}
      <div className="mt-4 text-xs text-gray-600 border border-gray-300 p-2 bg-gray-50 print:hidden">
        Report generated by ERP-Software - www.infraconsoft.com owned by www.nissiinfotech.com
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          body { margin: 0; }
          .print\\:hidden { display: none !important; }
          .print\\:p-0 { padding: 0 !important; }
          .print\\:max-w-none { max-width: none !important; }
          @page { 
            margin: 0.3in; 
            size: landscape;
          }
        }
      `}</style>
    </div>
  );
};

export default EmployeeMasterReportPrint;